import './App.css';
import { BrowserRouter, Switch, Route } from "react-router-dom"
import React,{createRef, useState} from 'react';
import Footer from './components/Footer/Footer.jsx';
import Award from './components/Body/Award.jsx';
import Experience from './components/Body/Experience.jsx';
import Project from './components/Body/Project.jsx';
import About from './components/Body/About.jsx';
import Home from './components/Body/Home.jsx';
import Header from "./components/Header/Header.jsx"


function App() {
  const [isVisible, setstate] = useState(false);

  const toggleVisible = () => {
    setstate(!isVisible)
  };
  
  return (
    <BrowserRouter>
			<Switch>
				<Route exact path='/'>
					<Header />
				</Route>
      </Switch>
    </BrowserRouter>
  );
}

export default App;
